import { Injectable } from '@angular/core';
import { DictionaryService } from '@app/core/services/dictionary.service';
import { Agency } from '@app/models';
import { TrainType } from '@app/pcs/models';
import { resolveAgencySubTypeIds } from '@app/pcs/util/train-type';
import { containsAnyAgencySubTypeIdWithId, getId, isImAgency } from '@app/util';
import * as R from 'ramda';

@Injectable()
export class AgencyService {

  constructor(private dictionaryService: DictionaryService) {
  }

  getAgencies() {
    return this.dictionaryService.getAgencies();
  }

  setAgencies(agencies: Agency[]) {
    this.dictionaryService.setAgencies(agencies);
  }

  getAgencyById(agencyId) {
    return R.find((agency: Agency) => agency.id === agencyId, this.getAgencies());
  }

  getImAgencies() {
    return R.filter(isImAgency, this.getAgencies());
  }

  getAgenciesAndFilterUnknown() {
    const isNotUnknownAgency = (agency: Agency) => R.not(agency.unknownAgency);
    return R.filter(isNotUnknownAgency, this.getAgencies());
  }

  getAgencyTypeIds() {
    return this.dictionaryService.getAgencyTypeIds();
  }

  getAgencySubTypeIds() {
    return this.dictionaryService.getAgencySubTypeIds();
  }

  getAgenciesByCountryId(countryId: string) {
    const byCountry = (agency: Agency) => R.equals(countryId, R.path(['country', 'id'])(agency));
    return R.filter(byCountry, this.getImAgencies());
  }

  getAllApplicantAgenciesByTrainType(trainType: TrainType) {
    const trainTypeId = R.prop('id', trainType);
    const agencySubTypeIds = resolveAgencySubTypeIds(trainTypeId);
    return R.filter((agency: Agency) => agency.applicant && containsAnyAgencySubTypeIdWithId(agencySubTypeIds)(agency), this.getAgencies());
  }

  getAgencySubTypesWithIds(agencySubTypeIds: string[]) {
    const containsAgencySubTypeId = R.compose((id) => R.includes(id, agencySubTypeIds), getId);
    return R.filter(containsAgencySubTypeId, this.getAgencySubTypeIds());
  }

  getAllApplicantsAndRusByTrainType(trainType: TrainType) {
    const trainTypeId = R.prop('id', trainType);
    const agencySubTypeIds = resolveAgencySubTypeIds(trainTypeId);
    return R.filter(
      (agency: Agency) => (agency.applicant || agency.ru) && containsAnyAgencySubTypeIdWithId(agencySubTypeIds)(agency),
      this.getAgencies()
    );
  }

}
